import { Component, Vue } from "vue-property-decorator";
import { Company } from "../../models";
import { camelToUnderscore } from "../../utils/Typography";

@Component
export default class CompaniesMixin extends Vue {
  readonly path = camelToUnderscore(Company.type);
  readonly routes = this.$getModelRoutes(this.path);

  getCompanies(data: any, tag) {
    return this.$httpGet(this.routes.indexUrl(data), tag);
  }

  getCompany(id: number | string, tag) {
    return this.$httpGet(this.routes.getUrl(id), tag);
  }

  destroyCompany(id, tag) {
    return this.$httpDelete(this.routes.deleteUrl(id), tag, null);
  }

  createCompany(data: any, tag) {
    return this.$httpPost(this.routes.createUrl(), tag, data);
  }

  updateCompany(id: string, data: any, tag) {
    return this.$httpPut(this.routes.updateUrl(id), tag, data);
  }
}
